import React from 'react'

/*
 * Use this context to provide data to a specific page
 * Use PackContext.Provider in the page
 * Generally we use it to supply page specific params e.g. callbacks or props
 * that need to be available through deeply nested components
 */

/*
  * Type Usage as follows:
  * Context Provider: Define Payload
  * i.e. export type PackContextPayload = {
            callbacks: {
              resetFilters: () => void,
              showImportContactsModal: () => void,
              updateFilters: () => void,
            },
            defaultFilters: object,
          }
  *
  * Context Consumer: Import types
  * import type { DefaultContext } from '@contexts/packContext'
  * import type { PackContextPayload } from '../../index'
  *
  * const packContext = useContext<DefaultContext<PackContextPayload>>(PackContext)
  */

export type DefaultContext<Payload = any> = {} & Payload
const data: DefaultContext = {}

// Old way - Remove after being refactored out
export type PackContextPayload = {
  [key: string]: any,
}

const PackContext = React.createContext<PackContextPayload>(data)

export default PackContext
